import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './custom.css';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { getPersistor } from '@rematch/persist';
import { store } from './rematch/store';
import { ErrorBoundary } from 'components/Container';

ReactDOM.render(
	<React.StrictMode>
		<ErrorBoundary>
			<Provider store={store}>
				<PersistGate persistor={getPersistor()}>
					<App />
				</PersistGate>
			</Provider>
		</ErrorBoundary>
	</React.StrictMode>,
	document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
